import React, { useEffect, useState } from "react";
import { connect } from 'react-redux'
import Loading from "../../../../components/Loading";
import { updateInputError, updateBodyCloud } from "../../../../redux/actions/DeploymentActions";
import styles from './CloudForm.module.scss'
import { generateSlug } from "../../../../helpers/common";
import Card, { CardItem } from "../../../../components/card/Card";
import Switch from "../../../../components/Switch";
import FormDynamic from "../../../../components/FormDynamic";
import CloudToken from "./components/CloudToken";
import DiskCategory from "./components/DiskCategory";

export const ANCHOR_CLOUD = 'cloud-container';

function CloudForm({
                       currentCloud, errorsInputs, dispatch, bodyCloud,
                       // builder
                       custom, token, tokens, setToken, loadingTokens, deleteToken,
                       messages,
                   }) {

    const [error, setError] = useState(false);
    const [cloudForm, setCloudForm] = useState(null);
    const [isForm, setIsForm] = useState(!custom);

    useEffect(() => {

        const {config} = currentCloud || {};

        if (!!config?.cloudForm?.length) {
            let fieldsData = [...config.cloudForm.filter(i => i.type === 'field')];
            if (fieldsData?.length) {
                let fields = {};
                fieldsData.map(f => fields[f.name] = '');
                dispatch(updateBodyCloud(fields));
            }
            setCloudForm(config.cloudForm)
        } else {
            setError(true)
        }
    }, []);

    useEffect(() => {
        if (custom && !loadingTokens) {
            if (!!tokens?.length) {
                setToken(tokens[0]);
                setIsForm(false);
            } else {
                setToken(null);
                setIsForm(true);
            }
        }
    }, [loadingTokens, tokens])

    const commonNote = {

        "type": "note",
        "icon": "fas fa-exclamation-circle",
        "title": "Important note",
        "text": {
            "blocks": [
                {
                    "key": "3l84o",
                    "text": "For increased security, we do not keep user credentials in our database. A token will be used to create your server and will then be deleted automatically once used.",
                    "type": "unstyled",
                    "depth": 0,
                    "inlineStyleRanges": [
                        {
                            "offset": 0,
                            "length": 165,
                            "style": "ITALIC"
                        }
                    ],
                    "entityRanges": [],
                    "data": {}
                }
            ],
            "entityMap": {}
        }
    }

    const renderForm = (filteredMessages) => {

        const form = [...cloudForm, ...[commonNote]];

        let values = {};
        form.map(item => {
            if (item.type === 'field') {
                values[item.name] = bodyCloud[item.name]
            }
        })

        return (
            <FormDynamic
                form={form}
                onChange={values => dispatch(updateBodyCloud(values))}
                values={values}
                setErrors={errors => dispatch(updateInputError(errors))}
                // errors={errorsInputs}
                messages={filteredMessages}
                createInternalHelpLink={field => (`/clouds/deploy-to-${generateSlug(currentCloud?.name)}`)}
                isForm={isForm}
                custom
            />
        )
    }

    const renderTokens = () => {
        return tokens.map((_token, index) => {

            const active = _token.id === token?.id && !isForm;
            const isActive = active ? ' ' + styles['token--active'] : '';

            return (
                <CardItem
                    onClick={() => {
                        setIsForm(false);
                        setToken(_token);
                    }}
                    className={`${styles.token}${isActive}`}
                    key={index}
                >
                    <div className={styles.token__icon}>
                        <i className={`far fa-circle ${styles.token__icon__circle}`}/>
                        <i className={`fas fa-circle ${styles.token__icon__dot}`}/>
                    </div>
                    <CloudToken token={_token} onDelete={deleteToken}/>
                </CardItem>
            )
        })
    }

    const renderContent = (filteredMessages) => (
        <div>
            {
                !!error &&
                <div className={styles.content__error}>
                    <i
                        className={`fas fa-exclamation-triangle ${styles.content__error__icon}`}
                        aria-hidden="true"
                    />
                    <div className={styles.content__error__message}>
                        <p>The cloud provider is under maintenance.</p>
                        <p>
                            Please try again later or <a onClick={() => Tawk_API.toggle({start: ''})}>contact
                            support</a> if you see this.
                        </p>
                    </div>
                </div>
            }
            {!error && !cloudForm?.length && <Loading type='component-cover'/>}
            {
                !error && !!cloudForm?.length &&
                <div className={styles.form}>
                    {renderForm(filteredMessages)}
                </div>
            }
            {currentCloud.code === 'ali' && <DiskCategory/>}
            {
                !!custom &&
                <div className={styles.bottom}>
                    <i className={`fas fa-save ${styles.bottom__icon}`}/>
                    <Switch
                        className={styles.bottom__switch}
                        title='Keep my cloud token securely for future server management'
                        // description='For increased security, we do not keep user credentials in our database. A token will be used to create your server and will then be deleted automatically once used.'
                        value={bodyCloud.save_token}
                        onChange={e => dispatch(updateBodyCloud({save_token: e}))}
                    />
                </div>
            }
        </div>
    );

    const renderFormLayout = (filteredMessages) => {
        if (custom) {
            const active = isForm && !token;
            const isActive = active ? ' ' + styles['token--active'] : '';
            return (
                <CardItem
                    onClick={() => {
                        setIsForm(true);
                        setToken(null);
                    }}
                    className={`${styles.token} ${styles['token--form']}${isActive}`}
                    messages={filteredMessages}
                    id={ANCHOR_CLOUD}
                >
                    <div className={styles.token__icon}>
                        <i className={`far fa-circle ${styles.token__icon__circle}`}/>
                        <i className={`fas fa-circle ${styles.token__icon__dot}`}/>
                    </div>
                    {renderContent(filteredMessages)}
                </CardItem>
            )
        } else {
            return (
                <CardItem className={styles.content} messages={filteredMessages} id={ANCHOR_CLOUD}>
                    {renderContent(filteredMessages)}
                </CardItem>
            )
        }
    }

    const filteredMessages = !isForm ? messages.filter(m => m.container !== ANCHOR_CLOUD) : messages;

    return (
        <Card
            style={{marginBottom: '10px'}}
            title={!custom ? 'Cloud credentials' : `Connect ${currentCloud.name || currentCloud.code || 'cloud'}`}
            id={ANCHOR_CLOUD}
            messages={filteredMessages}
            // showMessages
        >
            {
                loadingTokens
                    ?
                    <Loading/>
                    :
                    <>
                        {!!custom && renderTokens()}
                        {renderFormLayout(filteredMessages)}
                    </>
            }
        </Card>
    );
}

const mapStateToProps = state => ({
    currentCloud: state.deployment.currentCloud,
    errorsInputs: state.deployment.errorsInputs,
    bodyCloud: state.deployment.bodyCloud,
    messages: state.deployment.messages,
});

export default connect(mapStateToProps)(CloudForm)